/**
 * Terminus Nav Component v1.0.0
 */
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
} from '@angular/core';
import {
  MatLegacyMenuModule as MatMenuModule,
  MatLegacyMenuTrigger as MatMenuTrigger,
} from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BadgeModule } from 'primeng/badge';
import {
  isNavItemLink,
  NavData,
  NavItem,
  NavMenu,
  NavPlatformData,
  NavProfileData,
} from '../../models/nav.model';
import { UserInfo } from '../../models/user-info.model';
import { NavItemComponent } from '../nav-item/nav-item.component';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { NavPlatformSwitcherComponent } from '../nav-platform-switcher/nav-platform-switcher.component';
import { NavProfileComponent } from '../nav-profile/nav-profile.component';
import { NavPlatformSwitcherMenuComponent } from './../nav-platform-switcher-menu/nav-platform-switcher-menu.component';
import { NavProfileMenuComponent } from './../nav-profile-menu/nav-profile-menu.component';

@Component({
  selector: 'tux-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  imports: [
    CommonModule,
    FontAwesomeModule,
    MatMenuModule,
    NavItemComponent,
    NavPlatformSwitcherComponent,
    NavPlatformSwitcherMenuComponent,
    NavProfileComponent,
    NavProfileMenuComponent,
    NavMenuComponent,
    RouterModule,
    BadgeModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavComponent {
  @Input() appName: string;
  @Input() navData: NavData | null;
  @Input() user: UserInfo;
  @Input() impersonatingUser = false;
  @Input() navProfileData: NavProfileData;
  @Input() navPlatformData: NavPlatformData;
  @Input() domain: string; // top level domain, used in platform switcher menu
  @Input() homeLink: string = '';

  @ViewChild('navMenuTrigger', { read: MatMenuTrigger })
  navMenuTrigger: MatMenuTrigger;
  @ViewChild('navPlatformMenuTrigger', { read: MatMenuTrigger })
  navPlatformMenuTrigger: MatMenuTrigger;
  @ViewChild('navProfileMenuTrigger', { read: MatMenuTrigger })
  navProfileMenuTrigger: MatMenuTrigger;

  activeNavMenu?: NavMenu = undefined;

  handleNavItemClick(navItem: NavItem) {
    if (isNavItemLink(navItem) || this.activeNavMenu === navItem) {
      this.closeAllMenus();
    } else {
      this.activeNavMenu = navItem;
      this.navMenuTrigger.openMenu();
    }
  }

  closeAllMenus({
    except,
  }: { except?: 'profile' | 'platform-switcher' | 'subnav' } = {}) {
    if (!(except && except === 'subnav')) {
      this.navMenuTrigger.closeMenu();
      this.activeNavMenu = undefined;
    }

    if (!(except && except === 'profile'))
      this.navProfileMenuTrigger.closeMenu();

    if (!(except && except === 'platform-switcher'))
      this.navPlatformMenuTrigger.closeMenu();
  }
}
